import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { Token } from '../models/token';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // install an error handler
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401 || err.status === 406) {
          let error: any;
          if (typeof err.error === 'string') {
            try {
              error = JSON.parse(err.error);
            } catch {
              error = { message: err.error };
            }
          } else if (err.error && typeof err.error === 'object') {
            error = err.error;
          } else {
            error = { message: err.message || err.statusText };
          }
          this.removeTokens();
          this.router.navigate(['login']);
          return throwError(new Error(error.message));
        }
        return throwError(err);
      })
    );
  }

  private removeTokens() {
    const tokenStorage = environment.strictLogout
      ? sessionStorage
      : localStorage;
    tokenStorage.removeItem(Token.tokeNameInSotage);
    tokenStorage.removeItem(Token.refreshTokenNameInStorage);
  }
}
